import { FC } from "react";
import { Box, Container, Heading, Text, VStack, Flex } from "@chakra-ui/react";
import { LandingPageContent } from "@/constants/landingPages";

interface LandingHowItWorksSectionProps {
  content: LandingPageContent["howItWorks"];
}

export const LandingHowItWorksSection: FC<LandingHowItWorksSectionProps> = ({ content }) => (
  <Box py={{ base: "16", md: "24" }} bg="white">
    <Container maxW="5xl">
      <VStack spacing="12">
        {/* Section header */}
        <Heading as="h2" fontSize={{ base: "3xl", md: "4xl" }} color="gray.900" textAlign="center">
          {content.title}
        </Heading>

        {/* Steps */}
        <VStack spacing="6" w="100%" align="stretch">
          {content.steps.map((step) => (
            <Flex
              key={step.id}
              gap="6"
              align="flex-start"
              bg="gray.50"
              p="6"
              borderRadius="lg"
              transition="all 0.3s"
              _hover={{
                bg: "blue.50",
                transform: "translateX(4px)",
              }}
            >
              {/* Step number */}
              <Flex
                minW="12"
                h="12"
                align="center"
                justify="center"
                bg="blue.500"
                color="white"
                borderRadius="full"
                fontSize="xl"
                fontWeight="bold"
              >
                {step.id}
              </Flex>

              {/* Step content */}
              <VStack align="flex-start" spacing="2" flex="1">
                <Heading as="h3" fontSize="xl" color="gray.900">
                  {step.title}
                </Heading>
                <Text color="gray.600" lineHeight="1.7">
                  {step.description}
                </Text>
              </VStack>
            </Flex>
          ))}
        </VStack>
      </VStack>
    </Container>
  </Box>
);
